import {
  createContext,
  useState,
  useContext,
  ReactNode,
  // useEffect,
} from "react";
// import devLogger from "../utils/devLogger";
import { CaseContextType, CaseContextValue } from "../types";
import { defaultCase } from "../components/SubmitTip/resources";
import { useAuth } from "./AuthContext";

const CaseContext = createContext<CaseContextValue | undefined>(undefined);

export const CaseProvider = ({ children }: { children: ReactNode }) => {
  const { user } = useAuth();

  const [caseData, setCaseData] = useState<CaseContextType>(defaultCase(user));

  const updateCaseData = (field: keyof CaseContextType, value: any) => {
    setCaseData((prevData) => ({
      ...prevData,
      [field]: value,
    }));
  };

  const resetCaseData = () => {
    setCaseData(defaultCase(user));
  };

  // useEffect(() => {
  //   devLogger.log(caseData);
  // }, [caseData]);

  const contextValue: CaseContextValue = {
    ...caseData,
    updateCaseData,
    resetCaseData,
  };

  return (
    <CaseContext.Provider value={contextValue}>{children}</CaseContext.Provider>
  );
};

export const useCaseContext = () => {
  const context = useContext(CaseContext);
  if (!context) {
    throw new Error("useCaseContext must be used within a CaseProvider");
  }
  return context;
};
